import React from "react";
import Typography from "@mui/material/Typography";

interface IHeadline {
  title: string;
  subtitle?: string;
  addSpace?: boolean;
  color?: string;
  showAlways?: boolean;
}

// Only render when there is no customer h1 Element
const Headline: React.FC<IHeadline> = ({ title, subtitle, addSpace = true, color = "black", showAlways = false }) => {
  const isRoot = window.location.pathname === "/";

  if ((isRoot || !title) && !showAlways) return null;

  return (
    <>
      <Typography
        variant="h1"
        textAlign="center"
        color={color}
        sx={{
          color: `${color} !important`,
          fontSize: (theme) => `calc(${theme.typography.h1.fontSize} * 1.25) !important`,
          ...(addSpace && { mt: 1, mb: 2 })
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h2"
          textAlign="center"
          color={color}
          sx={{
            color: `${color} !important`,
            fontSize: (theme) => `calc(${theme.typography.h2.fontSize} * 1.25) !important`,
            ...(addSpace ? { mb: 4 } : {})
          }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  );
};

export default Headline;
